import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../../common/MessageScreen";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@inject("externalInterfaceStore")
export class SIdentitySettingsAddDeviceSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("sidentitySettings.addDevice.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="sidentitySettings.addDevice.success.message" />}
                buttonLabelId="common.close"
                onDismiss={() => pushRoute(SIdentitySettingsRoutes.ROOT)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsAddDeviceSuccess.tsx